'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("contrepartieService", function ($http, $q) {
  var contrepartiesColorsMap = [];
  var groupeSort = function groupeSort(g1, g2) {
    if (g1.isDefault) {
      return 1;
    } else if (g2.isDefault) {
      return -1;
    } else {
      var attrA = g1.libelleJuridique.toLowerCase();
      var attrB = g2.libelleJuridique.toLowerCase();
      return attrA < attrB ? -1 : attrA > attrB ? 1 : 0;
    }
  };
  var fetchContrepartieUsedInCompte = function fetchContrepartieUsedInCompte() {
    return $http.get("/rest/contreparties/contrepartiesId").then(function (response) {
      return response.data;
    });
  };
  var fetchGroupesBanquaires = function fetchGroupesBanquaires() {
    // les groupes bancaires, avec leurs banques (cf. GroupeBancaireDTO)
    return $http.get('/rest/contreparties/groupesBancaires').then(function (response) {
      return response.data;
    });
  };
  var fetchGroupesFinanceurs = function fetchGroupesFinanceurs() {
    // les groupes bancaires, avec leurs banques (cf. GroupeBancaireDTO)
    return $http.get('/rest/contreparties/groupesFinanceurs').then(function (response) {
      return response.data;
    });
  };
  var fetchFinanceursSubventions = function fetchFinanceursSubventions() {
    // les financeurs (cf. FinanceurSubventionDTO)
    return $http.get('/rest/contreparties/financeurs-subvention').then(function (response) {
      return response.data;
    });
  };
  return {
    $load: function $load() {
      return $http.get("/rest/contreparties/compte-contreparties-colors-info").then(function (response) {
        contrepartiesColorsMap = response.data;
      });
    },
    getContrepartieColor: function getContrepartieColor(id) {
      return contrepartiesColorsMap[id];
    },
    /**
     * liste des banques (BanqueDTO) dans les groupe avec en plus  {groupLabel = group.libelleJuridique, $inCompte = true si inclu dans les produits du compte}
     */
    getContreparties: function getContreparties() {
      return $q.all({
        ids: fetchContrepartieUsedInCompte(),
        groupesBancaires: fetchGroupesBanquaires()
      }).then(function (_ref) {
        var ids = _ref.ids,
          groupesBancaires = _ref.groupesBancaires;
        groupesBancaires.sort(groupeSort);
        var banques = [];
        _.each(groupesBancaires, function (group) {
          _.each(group.banques, function (banque) {
            banque.groupLabel = group.libelleJuridique;
            banque.$inCompte = _.includes(ids, banque.id);
            banques.push(banque);
          });
        });
        return banques;
      });
    },
    /**
     * @returns liste des financeurs
     */
    getFinanceursSubvention: function getFinanceursSubvention() {
      return $q.all({
        ids: fetchContrepartieUsedInCompte(),
        groupesFinanceurs: fetchGroupesFinanceurs()
      }).then(function (_ref2) {
        var ids = _ref2.ids,
          groupesFinanceurs = _ref2.groupesFinanceurs;
        groupesFinanceurs.sort(groupeSort);
        var financeurs = [];
        _.each(groupesFinanceurs, function (group) {
          _.each(group.financeurs, function (financeur) {
            financeur.groupLabel = group.libelleJuridique;
            financeur.$inCompte = _.includes(ids, financeur.id);
            financeurs.push(financeur);
          });
        });
        return financeurs;
      });
    },
    /**
     *
     * @returns {*} un BanqueDTO
     */
    getCDC: function getCDC() {
      return $http.get('/rest/contreparties/cdc').then(function (response) {
        return response.data;
      });
    },
    /**
     *
     * @returns {*} un BanqueDTO
     */
    getBanquePostale: function getBanquePostale() {
      return $http.get('/rest/contreparties/banque-postale').then(function (response) {
        return response.data;
      });
    },
    /**
     *
     * @returns {*} un BanqueDTO
     */
    getCACIB: function getCACIB() {
      return $http.get('/rest/contreparties/CA-CIB').then(function (response) {
        return response.data;
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/services/contrepartieService.js
// module id = 2868
// module chunks = 13